import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconComponents({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M6.615 7c.51 0 .923.448.923 1v5c0 .552-.413 1-.923 1H2.923C2.413 14 2 13.552 2 13V8c0-.552.413-1 .923-1h3.692zm6.462 3c.51 0 .923.448.923 1v2c0 .552-.413 1-.923 1H9.385c-.51 0-.923-.448-.923-1v-2c0-.552.413-1 .923-1h3.692zM6.615 8H2.923v5h3.692V8zm6.462 3H9.385v2h3.692v-2zm0-9c.51 0 .923.448.923 1v5c0 .552-.413 1-.923 1H9.385c-.51 0-.923-.448-.923-1V3c0-.552.413-1 .923-1h3.692zm0 1H9.385v5h3.692V3zM6.615 2c.51 0 .923.448.923 1v2c0 .552-.413 1-.923 1H2.923C2.413 6 2 5.552 2 5V3c0-.552.413-1 .923-1h3.692zm0 1H2.923v2h3.692V3z"/>
        </svg>
    );
}

export default IconComponents;
